// Visitor's personal filter panel layout (which extra fields are shown + order).
// Persisted to localStorage so it survives reloads on the same browser.
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useFilterLayout = create(
  persist(
    (set) => ({
      extraFields: [],
      fieldOrder: [],
      toggleExtra: (id) =>
        set((state) => {
          const has = state.extraFields.includes(id);
          return {
            extraFields: has ? state.extraFields.filter((x) => x !== id) : [...state.extraFields, id],
            fieldOrder: has ? state.fieldOrder.filter((x) => x !== id) : state.fieldOrder,
          };
        }),
      removeExtra: (id) =>
        set((state) => ({
          extraFields: state.extraFields.filter((x) => x !== id),
          fieldOrder: state.fieldOrder.filter((x) => x !== id),
        })),
      setOrder: (ids) => set({ fieldOrder: ids }),
      resetLayout: () => set({ extraFields: [], fieldOrder: [] }),
    }),
    { name: 'casahom-filter-layout' }
  )
);
